import { useLocation, Navigate } from "react-router"
import { PublicBooking } from "../types/service.type"
import { ConfirmationSection } from "./sections/confirmation/ConfirmationSection"
import { useGetProject } from "../hooks/useGetProject"
import { Loading } from "./Loading"
import NotFound from "./NotFound"

function Confirmation() {
  const { state } = useLocation()
  const { project, isLoading } = useGetProject()

  let booking: PublicBooking | undefined

  if (state && (state as { booking?: PublicBooking }).booking) {
    booking = (state as { booking: PublicBooking }).booking
  }

  if (!booking) {
    const storedBooking = localStorage.getItem("bookingData")
    if (storedBooking) {
      booking = JSON.parse(storedBooking) as PublicBooking
    }
  }

  if (!booking) {
    return <Navigate to="/" replace />
  }

  if (isLoading) {
    return <Loading />
  }

  if (!project) {
    return <NotFound />
  }

  return <ConfirmationSection booking={booking} project={project} />
}

export default Confirmation
